import { render, staticRenderFns } from "./inskin.vue?vue&type=template&id=4adfac65&"
import script from "./inskin.vue?vue&type=script&lang=js&"
export * from "./inskin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports